import { jsx as _jsx } from "react/jsx-runtime";
import { pdfjs, Document, Page } from "react-pdf";
import DisplayHtmlContent from "./DisplayHtmlContent";
import { clientConfigFn } from "clientConfig";
import { useState } from "react";
import { GetAssetUri } from "core/util/pathsHelper";
pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
const PrivacyPolicy = () => {
    const { showPdfPrivacyPolicy } = clientConfigFn();
    const [numPages, setNumPages] = useState();
    const screenSize = window.innerWidth;
    const mobileScreenSize = screenSize <= 959;
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    if (showPdfPrivacyPolicy) {
        return (_jsx("div", { className: "legal-document-container", children: _jsx(Document, { file: GetAssetUri("/client/misc/privacyPolicy.pdf"), onLoadSuccess: onDocumentLoadSuccess, className: "privacy-policy-document", loading: "Privacy Policy", children: Array.from(new Array(numPages), (_el, index) => (_jsx(Page, { pageNumber: index + 1, scale: mobileScreenSize ? 0.75 : 2, className: "privacy-policy-page", loading: "", renderTextLayer: false, renderAnnotationLayer: false }, `page_${index + 1}`))) }) }));
    }
    return (_jsx(DisplayHtmlContent, { errorMessage: "Could not load Privacy Policy", url: GetAssetUri("/client/misc/privacyPolicy.html") }));
};
export default PrivacyPolicy;
